var map = {
	"./average-feedback.png": 963,
	"./bad-feedback.png": 562,
	"./bottom-blob.png": 895,
	"./bottom-sphere.png": 933,
	"./ellipse-1.png": 863,
	"./ellipse-2.png": 520,
	"./good-feedback.png": 158,
	"./robot-arm.png": 405,
	"./scenario-1.png": 789,
	"./scenario-2.png": 925,
	"./scenario-3.png": 474,
	"./scenario-4.png": 414,
	"./scenario-5.png": 517,
	"./top-blob.png": 85,
	"./top-right-sphere.png": 764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;